import { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import Layout from '../components/layout';
import Title from '../components/title';
import Statscard from '../components/statscard';
import './testimonials.css';
import searchIcon from '../assets/search.svg';
import dropdownIcon from '../assets/dropdown.svg';
import editIcon from '../assets/edit.svg';
import deleteIcon from '../assets/delete.svg';
import ratingIcon from '../assets/rating.svg';
import peopleIcon from '../assets/people.svg';

const TESTIMONIALS_PER_PAGE = 4;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedRole, setSelectedRole] = useState('All Roles');
  const [currentPage, setCurrentPage] = useState(1);
  const [isAddTestimonialOpen, setIsAddTestimonialOpen] = useState(false);
  const [isEditTestimonialOpen, setIsEditTestimonialOpen] = useState(false);

  const [id, setId] = useState('');
  const [editUserId, setEditUserId] = useState('');
  const [editRole, setEditRole] = useState('');
  const [editRoleAr, setEditRoleAr] = useState('');
  const [editContentEn, setEditContentEn] = useState('');
  const [editContentAr, setEditContentAr] = useState('');
  const [editRating, setEditRating] = useState('5');

  const [addUserId, setAddUserId] = useState('');
  const [addRole, setAddRole] = useState('');
  const [addRoleAr, setAddRoleAr] = useState('');
  const [addContentEn, setAddContentEn] = useState('');
  const [addContentAr, setAddContentAr] = useState('');
  const [addRating, setAddRating] = useState('5');

  const fetchTestimonials = async () => {
    const res = await supabase
      .from("Testimonials")
      .select(`
        *,
        Users(name)
      `);

    setTestimonials(res.data || []);
  };

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const createTestimonial = async (e) => {
    e.preventDefault();

    const { error } = await supabase.from("Testimonials").insert([{
      user_id: addUserId,
      role: addRole,
      role_ar: addRoleAr,
      content: addContentEn,
      content_ar: addContentAr,
      rating: addRating,
    }]);

    if (error) {
      alert("Failed to create testimonial: " + error.message);
      return;
    }

    await fetchTestimonials();

    setAddUserId('');
    setAddRole('');
    setAddRoleAr('');
    setAddContentEn('');
    setAddContentAr('');
    setAddRating('5');

    setIsAddTestimonialOpen(false);
  };

  const editTestimonial = (item) => {
    setId(item.id);
    setEditUserId(item.user_id);
    setEditRole(item.role);
    setEditRoleAr(item.role_ar);
    setEditContentEn(item.content);
    setEditContentAr(item.content_ar);
    setEditRating(item.rating);
    setIsEditTestimonialOpen(true);
  };

  const updateTestimonial = async (e) => {
    e.preventDefault();

    await supabase
      .from("Testimonials")
      .update({
        user_id: editUserId,
        role: editRole,
        role_ar: editRoleAr,
        content: editContentEn,
        content_ar: editContentAr,
        rating: editRating,
      })
      .eq('id', id);

    await fetchTestimonials();
    setIsEditTestimonialOpen(false);
  };

  const deleteTestimonial = async (id) => {
    await supabase.from("Testimonials").delete().eq('id', id);
    await fetchTestimonials();
  };

  const roleOptions = [...new Set(testimonials.map((t) => t.role))];

  const filteredTestimonials = testimonials.filter((t) => {
    const value = searchTerm.toLowerCase();

    const matchesRole =
      selectedRole === 'All Roles' ||
      t.role === selectedRole;

    const matchesSearch = (
      t.id.toString().includes(value) ||
      t.Users?.name?.toLowerCase().includes(value) ||
      t.role?.toLowerCase().includes(value) ||
      t.content?.toLowerCase().includes(value)
    );

    return matchesSearch && matchesRole;
  });

  const totalTestimonials = testimonials.length;
  const fiveStarTestimonials = testimonials.filter((t) => t.rating == 5).length;
  const avgRating = totalTestimonials > 0 
    ? (testimonials.reduce((sum, t) => sum + Number(t.rating), 0) / totalTestimonials).toFixed(1)
    : 0;

  const totalPages = Math.ceil(filteredTestimonials.length / TESTIMONIALS_PER_PAGE);
  const startIndex = (currentPage - 1) * TESTIMONIALS_PER_PAGE;
  const paginatedTestimonials = filteredTestimonials.slice(startIndex, startIndex + TESTIMONIALS_PER_PAGE);

  return (
    <Layout>
      <div className="testimonials_page">
        <Title
          subtitle="Manage app testimonials on the Eventra platform"
          title="TESTIMONIALS MANAGEMENT"
        />

        <div className="testimonials_stats">
          <Statscard
            change=""
            icon={peopleIcon}
            label="Total Testimonials"
            value={totalTestimonials}
          />
          <Statscard
            change=""
            icon={ratingIcon}
            label="5-Star Ratings"
            value={fiveStarTestimonials}
          />
          <Statscard
            change=""
            icon={ratingIcon}
            label="Average Rating"
            value={avgRating}
          />
        </div>

        <div className="testimonials_controls_card">
          <div className="testimonials_controls_left">
            <label className="testimonials_search" htmlFor="testimonials-search">
              <img alt="" src={searchIcon} />
              <input
                id="testimonials-search"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(1);
                }}
                placeholder="Search testimonials..."
                type="text"
                value={searchTerm}
              />
            </label>

            <div className="testimonials_filter">
              <select
                onChange={(e) => {
                  setSelectedRole(e.target.value);
                  setCurrentPage(1);
                }}
                value={selectedRole}
              >
                <option value="All Roles">All Roles</option>
                {roleOptions.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </select>
              <img alt="" src={dropdownIcon} />
            </div>
          </div>

          <button
            className="testimonials_add_button"
            onClick={() => setIsAddTestimonialOpen(true)}
            type="button"
          >
            <div>+</div>
            <div>Add Testimonial</div>
          </button>
        </div>

        <div className="testimonials_table_card">
          <div className="testimonials_table_top">
            <div className="testimonials_table_title">All Testimonials</div>
            <div className="testimonials_table_count">{filteredTestimonials.length} total</div>
          </div>

          <div className="testimonials_table_scroll">
            <div className="testimonials_row testimonials_table_head">
              <div className="testimonials_checkbox">
                <input type="checkbox" />
              </div>
              <div>ID</div>
              <div>Created At</div>
              <div>User</div>
              <div>Rating</div>
              <div>Role (EN)</div>
              <div>Content (EN)</div>
              <div>Actions</div>
            </div>

            <div className="testimonials_table_body">
              {paginatedTestimonials.map((item) => (
                <div className="testimonials_row" key={item.id}>
                  <div className="testimonials_checkbox">
                    <input type="checkbox" />
                  </div>

                  <div className="testimonials_cell_text">{item.id}</div>
                  <div className="testimonials_cell_text">{item.created_at.split('T')[0]}</div>
                  <div className="testimonials_cell_text">{item.Users?.name || item.user_id}</div>
                  <div className="testimonials_cell_text">{item.rating}</div>
                  <div className="testimonials_cell_text">{item.role}</div>
                  <div className="testimonials_cell_text">{item.content}</div>

                  <div className="testimonials_actions">
                    <button
                      className="testimonials_action_button"
                      onClick={() => editTestimonial(item)}
                      type="button"
                    >
                      <img alt="" src={editIcon} />
                    </button>
                    <button className="testimonials_action_button" onClick={() => deleteTestimonial(item.id)} type="button">
                      <img alt="" src={deleteIcon} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {totalPages > 1 && (
            <div className="testimonials_pagination">
              <button
                className="testimonials_pagination_button"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>
              <div className="testimonials_pagination_info">
                Page {currentPage} of {totalPages}
              </div>
              <button
                className="testimonials_pagination_button"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>
          )}
        </div>

        {isAddTestimonialOpen && (
          <div
            className="testimonials_modal_overlay"
            onClick={() => setIsAddTestimonialOpen(false)}
            role="presentation"
          >
            <div
              aria-modal="true"
              className="testimonials_modal"
              onClick={(event) => event.stopPropagation()}
              role="dialog"
            >
              <div className="testimonials_modal_header">
                <div className="testimonials_modal_heading">
                  <h2>ADD NEW TESTIMONIAL</h2>
                  <p>Fill in the details below to add a new user testimonial.</p>
                </div>

                <button
                  aria-label="Close add testimonial overlay"
                  className="testimonials_modal_close"
                  onClick={() => setIsAddTestimonialOpen(false)}
                  type="button"
                >
                  x
                </button>
              </div>

              <form
                className="testimonials_modal_form"
                onSubmit={createTestimonial}
              >
                <div className="testimonials_modal_grid">
                  <label className="testimonials_modal_field">
                    <span>User ID</span>
                    <input
                      onChange={(e) => setAddUserId(e.target.value)}
                      placeholder="Enter user ID"
                      type="number"
                      value={addUserId}
                    />
                  </label>

                  <label className="testimonials_modal_field">
                    <span>Rating</span>
                    <div className="testimonials_modal_select_wrap">
                      <select
                        onChange={(e) => setAddRating(e.target.value)}
                        value={addRating}
                      >
                        <option value="1">1 Star</option>
                        <option value="2">2 Stars</option>
                        <option value="3">3 Stars</option>
                        <option value="4">4 Stars</option>
                        <option value="5">5 Stars</option>
                      </select>
                      <img alt="" src={dropdownIcon} />
                    </div>
                  </label>

                  <label className="testimonials_modal_field">
                    <span>Role (English)</span>
                    <input
                      onChange={(e) => setAddRole(e.target.value)}
                      placeholder="Role in English"
                      type="text"
                      value={addRole}
                    />
                  </label>

                  <label className="testimonials_modal_field">
                    <span>Role (Arabic)</span>
                    <input
                      dir="rtl"
                      onChange={(e) => setAddRoleAr(e.target.value)}
                      placeholder="الدور باللغة العربية"
                      type="text"
                      value={addRoleAr}
                    />
                  </label>

                  <label className="testimonials_modal_field testimonials_modal_field_full">
                    <span>Content (English)</span>
                    <textarea
                      onChange={(e) => setAddContentEn(e.target.value)}
                      placeholder="Testimonial content in English"
                      rows={3}
                      value={addContentEn}
                    />
                  </label>

                  <label className="testimonials_modal_field testimonials_modal_field_full">
                    <span>Content (Arabic)</span>
                    <textarea
                      dir="rtl"
                      onChange={(e) => setAddContentAr(e.target.value)}
                      placeholder="محتوى التقييم باللغة العربية"
                      rows={3}
                      value={addContentAr}
                    />
                  </label>
                </div>

                <div className="testimonials_modal_actions">
                  <button
                    className="testimonials_modal_secondary_button"
                    onClick={() => setIsAddTestimonialOpen(false)}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button className="testimonials_modal_primary_button" type="submit">
                    Add Testimonial
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {isEditTestimonialOpen && (
          <div
            className="testimonials_modal_overlay"
            onClick={() => setIsEditTestimonialOpen(false)}
            role="presentation"
          >
            <div
              aria-modal="true"
              className="testimonials_modal"
              onClick={(event) => event.stopPropagation()}
              role="dialog"
            >
              <div className="testimonials_modal_header">
                <div className="testimonials_modal_heading">
                  <h2>EDIT TESTIMONIAL</h2>
                  <p>Update the testimonial details below.</p>
                </div>

                <button
                  aria-label="Close edit testimonial overlay"
                  className="testimonials_modal_close"
                  onClick={() => setIsEditTestimonialOpen(false)}
                  type="button"
                >
                  x
                </button>
              </div>

              <form
                className="testimonials_modal_form"
                onSubmit={updateTestimonial}
              >
                <div className="testimonials_modal_grid">
                  <label className="testimonials_modal_field">
                    <span>User ID</span>
                    <input
                      onChange={(e) => setEditUserId(e.target.value)}
                      placeholder="Enter user ID"
                      type="number"
                      value={editUserId}
                    />
                  </label>

                  <label className="testimonials_modal_field">
                    <span>Rating</span>
                    <div className="testimonials_modal_select_wrap">
                      <select
                        onChange={(e) => setEditRating(e.target.value)}
                        value={editRating}
                      >
                        <option value="1">1 Star</option>
                        <option value="2">2 Stars</option>
                        <option value="3">3 Stars</option>
                        <option value="4">4 Stars</option>
                        <option value="5">5 Stars</option>
                      </select>
                      <img alt="" src={dropdownIcon} />
                    </div>
                  </label>

                  <label className="testimonials_modal_field">
                    <span>Role (English)</span>
                    <input
                      onChange={(e) => setEditRole(e.target.value)}
                      placeholder="Role in English"
                      type="text"
                      value={editRole}
                    />
                  </label>

                  <label className="testimonials_modal_field">
                    <span>Role (Arabic)</span>
                    <input
                      dir="rtl"
                      onChange={(e) => setEditRoleAr(e.target.value)}
                      placeholder="الدور باللغة العربية"
                      type="text"
                      value={editRoleAr}
                    />
                  </label>

                  <label className="testimonials_modal_field testimonials_modal_field_full">
                    <span>Content (English)</span>
                    <textarea
                      onChange={(e) => setEditContentEn(e.target.value)}
                      placeholder="Testimonial content in English"
                      rows={3}
                      value={editContentEn}
                    />
                  </label>

                  <label className="testimonials_modal_field testimonials_modal_field_full">
                    <span>Content (Arabic)</span>
                    <textarea
                      dir="rtl"
                      onChange={(e) => setEditContentAr(e.target.value)}
                      placeholder="محتوى التقييم باللغة العربية"
                      rows={3}
                      value={editContentAr}
                    />
                  </label>
                </div>

                <div className="testimonials_modal_actions">
                  <button
                    className="testimonials_modal_secondary_button"
                    onClick={() => setIsEditTestimonialOpen(false)}
                    type="button"
                  >
                    Cancel
                  </button>
                  <button className="testimonials_modal_primary_button" type="submit">
                    Update Testimonial
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Testimonials;
